// ** MUI Imports
import IconButton from '@mui/material/IconButton';

// ** Icon Imports
import Icon from 'src/@core/components/icon';

const ModeToggler = (props) => {
  // ** Props
  const { settings, saveSettings } = props;

  const handleModeChange = (mode) => {
    saveSettings({ ...settings, mode });
  };

  const handleModeToggle = () => {
    if (settings.mode === 'light') {
      handleModeChange('dark');
    } else {
      handleModeChange('light');
    }
  };

  return (
    <IconButton
      aria-haspopup="true"
      color="inherit"
      onClick={handleModeToggle}
      size="large">
      <Icon
        fontSize="1.625rem"
        icon={settings.mode === 'dark' ? 'tabler:sun' : 'tabler:moon-stars'}
      />
    </IconButton>
  );
};

export default ModeToggler;
